module.exports = __webpack_public_path__ + "static/media/chat_settings_icon.3e8430d4.svg";